import clsx from 'clsx';

export default function ContentWrapper({ className, children, style }) {
  return (
    <div className={clsx('content-wrapper', className)} style={style}>
      {children}
    </div>
  );
}
